import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import '../css/ParticipantForm.css';
import api from '../utils/axiosConfig';


function ParticipantForm() {
  const [formData, setFormData] = useState({
    name: "",
    code: ""
  });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      const fetchParticipant = async () => {
        setLoading(true);
        try {
          const res = await api.get(`/api/participants/${id}`);
          setFormData({
            name: res.data.name,
            code: res.data.code
          });
        } catch (err) {
          console.error("Fetch error:", err);
          setError("Failed to load participant data");
        } finally {
          setLoading(false);
        }
      };
      fetchParticipant();
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    
    if (!formData.name.trim() || !formData.code.trim()) {
      setError("Name and code are required");
      return;
    }

    /* if (!/^[A-Za-z]{1,3}-\d{4}$/.test(formData.code)) {
      setError("Code must follow pattern like P-1001");
      return;
    } */

    // Validate code format
    if (!/^[1-9]{5}C[1-9]$/.test(formData.code)) {
      setError("Code must follow pattern: 12345C1 (5 digits + C + 1 digit)");
      return;
    }

    try {
      setLoading(true);
      if (id) {
        await api.put(`/api/participants/${id}`, formData);
      } else {
        await api.post(`/api/participants`, formData);
      }
      //navigate('/Dashboard');
      navigate('/dashboard/participants');
    } catch (err) {
      console.error("Save error:", err);
      if (err.response?.data?.error?.includes('duplicate')) {
        setError("This code already exists");
      } else {
        setError(err.response?.data?.message || "Failed to save participant");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  if (loading) return <div className="loading-message">Loading...</div>;

  return (
    <div className="participant-form-container">
      <h2 className="participant-form-title">Teilnehmer {id ? "bearbeiten" : "hinzufügen"}</h2>
      {error && <div className="error-message">{error}</div>}
      <form className="participant-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Code:</label>
          <input
            type="text"
            name="code"
            value={formData.code}
            onChange={handleChange}
            required
            pattern="[1-9]{5}C[1-9]"
            maxLength="7"
            title="Format: 12345C1 (5 digits + C + 1 digit)"
            placeholder="12345C1"
            disabled={!!id}
          />
        </div>
        <div className="form-group">
          <label>Name:</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-actions">
          <button 
            type="submit" 
            className="btn submit-btn" 
            disabled={loading}
            >
            {loading ? "Saving..." : "Speichern"}
          </button>
          <button 
            type="button" 
            className="btn cancel-btn"
            onClick={() => navigate("/dashboard/participants")}
            disabled={loading}
          >
            Abbrechen
          </button>
        </div>
      </form>
    </div>
  );
}

export default ParticipantForm;